import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput,
  Button
  // Button
} from "shards-react";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavLink } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import useMedia from "../modules/media/hooks";
import Pagination from "../components/blogpost/pagination";

const SearchButton = React.memo(()=> {
  const [search, setSearch] = useState("");
  const test = useRef(null)
  const {fetchBySearch} = useMedia();
  const searchBox = useCallback(e => {
    const {
      target: { value }
    } = e;
    setSearch(value);
  },[search]);
  
  const onSubmit = useCallback(e => {
    e.preventDefault();
    fetchBySearch(search);
  },[search])

  return(
    <Form
      className="main-navbar__search d-none d-md-flex d-lg-flex"
      style={{ flexBasis: "250px" }}
      onSubmit={onSubmit}
    >
      <InputGroup seamless className="ml-3">
        <InputGroupAddon type="prepend">
          <InputGroupText>
            <i className="material-icons">search</i>
          </InputGroupText>
        </InputGroupAddon>
        <FormInput
          className="navbar-search"
          placeholder="Search for something..."
          value={search}
          onChange={searchBox}
          ref={test}
        />
      </InputGroup>
    </Form>
  )
})

const MediaTable = React.memo(({history}) => {
  const {media,totalLength,pageNumber,fetchAllMedias} = useMedia();
  useEffect(() => {
    if (media.length !== 0) return;
    fetchAllMedias();
  }, []);
  return (
    <table className="table mb-0">
      <thead className="bg-light">
        <tr>
          <th width="6.50618%" scope="col" className="border-0" style={{paddingLeft:"30px"}}>
            #
          </th>
          <th width="46.66881%" scope="col" className="border-0">
            제목
          </th>
          <th width="15.1594%" scope="col" className="border-0">
            언론사
          </th>
          <th width="12.8002%" scope="col" className="border-0">
            보도일자
          </th>
          <th width="18.8002%" scope="col" className="border-0">
            등록일자
          </th>
        </tr>
      </thead>
      <tbody>
        {media.map((item, index) => (
          <tr
            onClick={e => {
              if (e.target.id !== "close") {
                history.push("/write", item.title);
              }
            }}
            style={{ cursor: "pointer", position: "relative" }}
            key={item.id}
          >
            <td style={{paddingLeft:"30px"}}>{totalLength -  (pageNumber - 1) * 10 - index}</td>
            {/* <td>{item.title}</td> */}
            <td>
              {item.title.slice(0, 40) +
                (item.title.length > 40 ? "..." : "")}
            </td>
            <td>{item.source}</td>
            <td>{
            // item.date
            typeof(item.date)=== "string" ? item.date.split(' ')[0]: "null"
            }</td>
            <td>{
              // typeof(item.regdate)=== "string" ? item.regdate.split(' ')[0]: "null"
              item.regdate
              }</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
})

const BlogPosts = ({ history }) => {
  
  const { loading } = useMedia();

  if (loading){
    return(<Container  fluid className="main-content-container px-4 pb-4" style={{display: "flex",
      alignItems: 'center',
      justifyContent: 'center'}}>
      로딩중입니다.
      <i className="material-icons" style={{fontSize:50, marginLeft:10}}>cached</i>
      </Container>)
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4" style={{position:'relative'}}>
        <PageTitle
          sm="4"
          title="미디어 관리"
          className="text-sm-left"
        />
        <div
          className="bg-primary text-white text-center rounded outline ml-auto"
          style={{
            display: "flex",
            alignItems: "center",
            // marginTop: 10,
            marginRight: 10,
            position:'absolute',
            right: "0px"
          }}
        >
          <NavLink tag={RouteNavLink} to="/write" className="text-white" >
            작성하기
          </NavLink>
        </div>
      </Row>

      {/* Default Light Table */}
      <Row>
        <Col>
          <Card
            small
            className="mb-4"
            style={{ position: "relative", height: "107%" }}
          >
            <CardHeader
              className="border-bottom"
              style={{ display: "flex", alignItems: "baseline" }}
            >
              <h6 className="m-0" style={{ flexGrow: 1, flexBasis: "100px" }}>
                전체
              </h6>
              <SearchButton/>
            </CardHeader>
            <CardBody className="p-0 pb-5">
                <MediaTable history={history}/>
                <Pagination
                  style={{ 
                    display:"flex",
                    position: "absolute", bottom: 10,  
                    justifyContent:'center'
                  }}
                />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

// export default Tables;
export default React.memo(BlogPosts);
